import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant } from "@/js/http/auth.js";
import { pricePostingStatusList } from "@/js/lists.ts";
import * as orderHandler from "@/js/order/order.js";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";

//SYNC WITH Back : PricePostingUsaProConstants
var NB_DAYS_DEFAULT_ADDED_FOR_DEFAULT_DATE = 5;
export default {
  name: "PricePostingUsaProSelector",
  components: {
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    isCartInProgress: Boolean,
    isDisabledIfCartInProgress: Boolean
  },
  data: function data() {
    return {
      pricePostingSelected: null,
      gettingPricePostingUsaProPosted: {
        items: [],
        isPending: false
      },
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.gettingPricePostingUsaProPosted.isPending || this.isCartInProgress && this.isDisabledIfCartInProgress;
    },
    inputPlaceholder: function inputPlaceholder() {
      var _this$pricePostingSel;
      var isLoading = this.gettingPricePostingUsaProPosted.isPending;
      var isSelected = !!((_this$pricePostingSel = this.pricePostingSelected) !== null && _this$pricePostingSel !== void 0 && _this$pricePostingSel.id) >= 0;
      if (isLoading) {
        return isSelected ? "Loading selected" : "Loading list";
      } else {
        return "Search";
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.fetchPricePostingUsaProPosted();
          case 2:
            _this2.pricePostingSelected = orderHandler.getPricePostingUsaSelected();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    selectPricePosting: function selectPricePosting() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              orderHandler.setPricePostingUsaSelected(_this3.pricePostingSelected);
              _this3.$emit("pricePostingChanged");
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchPricePostingUsaProPosted: function fetchPricePostingUsaProPosted() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response, noOne, today, firstDayNextMonth;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.gettingPricePostingUsaProPosted.isPending = true;
              _this = _this4;
              _context3.next = 4;
              return request("/v1/price-posting/usable?onlyStillAvailable=true", "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get available price postings");
                handleErrorData(_this, errorData);
                _this.gettingPricePostingUsaProPosted.isPending = false;
                throw e;
              });
            case 4:
              response = _context3.sent;
              noOne = {
                id: 0,
                applicationDate: moment().add(NB_DAYS_DEFAULT_ADDED_FOR_DEFAULT_DATE + 1, "days"),
                applicationDateString: "Future date | Live pricing"
              };
              today = moment();
              firstDayNextMonth = today.clone().add(1, "month");
              _this4.gettingPricePostingUsaProPosted.items = [noOne].concat(_toConsumableArray(response.data.value.map(function (x) {
                var applicationDate = moment(x.applicationDate);
                var expirationDate = x.expirationDate ? moment(x.expirationDate) : null;
                var applicationDateString = applicationDate.formatStringMonth();
                var isSameMonthAsToday = !expirationDate && today.isSame(applicationDate, "month");
                var isExactlyOneFullMonthOfApplication = expirationDate && expirationDate.month() === applicationDate.clone().add(1, "month").month() && expirationDate.year() === applicationDate.clone().add(1, "month").year();
                var isNextMonthOfApplication = applicationDate.isSame(firstDayNextMonth, "month");
                if (isSameMonthAsToday || isExactlyOneFullMonthOfApplication || isNextMonthOfApplication) {
                  // on ne change rien
                } else if (!expirationDate) {
                  applicationDateString += " → End of current month";
                } else {
                  var adjustedExpiration = expirationDate.clone().subtract(1, "day");
                  applicationDateString += " → " + adjustedExpiration.formatStringMonth();
                }
                if (isAdminNotConsultant(_this4.loggedUserData) && x.status == pricePostingStatusList.DRAFT.id) {
                  applicationDateString += " (draft)";
                }
                return _objectSpread(_objectSpread({}, x), {}, {
                  applicationDateString: applicationDateString
                });
              })));
              _this4.gettingPricePostingUsaProPosted.isPending = false;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getDefaultValue: function getDefaultValue() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var estimateDeliveryDate, candidates, selected;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!_this5.gettingPricePostingUsaProPosted.items.length > 0)) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return _this5.fetchPricePostingUsaProPosted();
            case 3:
              estimateDeliveryDate = moment().add(NB_DAYS_DEFAULT_ADDED_FOR_DEFAULT_DATE, "days");
              candidates = _this5.gettingPricePostingUsaProPosted.items.filter(function (item) {
                return item.applicationDate && moment(item.applicationDate).isBefore(estimateDeliveryDate);
              });
              selected = candidates.length ? candidates.reduce(function (closest, current) {
                return moment(current.applicationDate).isAfter(moment(closest.applicationDate)) ? current : closest;
              }) : null;
              if (!selected) {
                selected = _this5.gettingPricePostingUsaProPosted.items.find(function (item) {
                  return item.id === 0;
                });
              }
              return _context4.abrupt("return", selected);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    selectDefaultValue: function selectDefaultValue() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var selected;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!_this6.gettingPricePostingUsaProPosted.items.length > 0)) {
                _context5.next = 3;
                break;
              }
              _context5.next = 3;
              return _this6.fetchPricePostingUsaProPosted();
            case 3:
              _context5.next = 5;
              return _this6.getDefaultValue();
            case 5:
              selected = _context5.sent;
              _this6.pricePostingSelected = selected;
              _this6.selectPricePosting();
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    resetToNull: function resetToNull() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              orderHandler.removePricePostingUsaLocale();
              _this7.$emit("pricePostingChanged");
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    hasValueAvailable: function hasValueAvailable(id) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var item;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(!_this8.gettingPricePostingUsaProPosted.items.length > 0)) {
                _context7.next = 3;
                break;
              }
              _context7.next = 3;
              return _this8.fetchPricePostingUsaProPosted();
            case 3:
              item = _this8.gettingPricePostingUsaProPosted.items.find(function (x) {
                return x.id === id;
              });
              return _context7.abrupt("return", item !== undefined);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    setValue: function setValue(id) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var item;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!_this9.gettingPricePostingUsaProPosted.items.length > 0)) {
                _context8.next = 3;
                break;
              }
              _context8.next = 3;
              return _this9.fetchPricePostingUsaProPosted();
            case 3:
              item = _this9.gettingPricePostingUsaProPosted.items.find(function (x) {
                return x.id === id;
              });
              if (item !== undefined) {
                _this9.pricePostingSelected = item;
                _this9.selectPricePosting();
              }
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    checkPricePostingSelected: function checkPricePostingSelected() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this10$pricePostingS;
        var isStillAvailable;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(!_this10.gettingPricePostingUsaProPosted.items.length > 0)) {
                _context9.next = 3;
                break;
              }
              _context9.next = 3;
              return _this10.fetchPricePostingUsaProPosted();
            case 3:
              _this10.pricePostingSelected = orderHandler.getPricePostingUsaSelected();
              if (!(((_this10$pricePostingS = _this10.pricePostingSelected) === null || _this10$pricePostingS === void 0 ? void 0 : _this10$pricePostingS.id) > 0)) {
                _context9.next = 9;
                break;
              }
              _context9.next = 7;
              return _this10.hasValueAvailable(_this10.pricePostingSelected.id);
            case 7:
              isStillAvailable = _context9.sent;
              if (!isStillAvailable) {
                _this10.selectDefaultValue();
              }
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete
  }
};